// extracted by mini-css-extract-plugin
export default {"container":"topMenu_container__Iem4x","logo":"topMenu_logo__a4WkK","text":"topMenu_text__BQkbl","mobile_menu_container":"topMenu_mobile_menu_container__gc1yT"};